import React, { type FC, type ReactNode, useCallback, useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';

import { useDirection } from '@/hooks/useDirection.tsx';
import { createDirectionalStyles } from '@/utils/createDirectionalStyles.ts';

import components from './components/index.ts';
import mixins from './mixins.ts';
import palette from './palette.ts';
import shadows from './shadows.ts';
import typography from './typography.ts';

interface CustomThemeProviderProps {
  children: ReactNode;
}

export const CustomThemeProvider: FC<CustomThemeProviderProps> = ({ children }) => {
  const { direction } = useDirection();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const applyDirectionalStyles = useCallback(createDirectionalStyles(direction === 'rtl'), [direction]);

  const theme = useMemo(
    () =>
      createTheme({
        direction,
        components,
        typography,
        palette,
        shadows,
        shape: { borderRadius: 4 },
        mixins,
        applyDirectionalStyles
      }),
    [applyDirectionalStyles, direction]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
